import { useState } from "react";

export function useStorageState<S>(initialState: S, key: string, parser?: (str: string) => S): [stateVar: S, stateVarSetter: (newState: S) => void] {
	const defaultParser = (str: string) => JSON.parse(str) as S;
	if (!parser) parser = defaultParser;
	const initVal = localStorage.getItem(key);
	const [stateVar, setStateVar] = useState<S>(initVal == null || typeof (initVal) === "undefined" ? initialState : parser(initVal));
	const actualSetter = (newState: S) => {
		localStorage.setItem(key, JSON.stringify(newState));
		setStateVar(newState);
	}
	return [stateVar, actualSetter];
}